import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["calibrationSelect"]
  
  loadCalibrations(event) {
    const equipmentId = event.target.value
    const calibrationSelect = this.calibrationSelectTarget
    
    // Clear existing options
    calibrationSelect.innerHTML = '<option value="">Loading...</option>'
    
    if (!equipmentId) {
      calibrationSelect.innerHTML = '<option value="">Select equipment first...</option>'
      return
    }
    
    // Extract task ID from URL: app.limsey.com/jobs/27946/tasks/103565?nav=equipment_inventory&pannel=equipment
    const pathParts = window.location.pathname.split('/')
    const taskId = pathParts[4] // jobs is index 1, job_id is index 2, tasks is index 3, task_id is index 4
    
    // Fetch calibrations
    fetch(`/tasks/${taskId}/task_assignments/calibrations?equipment_id=${equipmentId}`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        calibrationSelect.innerHTML = '<option value="">None</option>'
        data.forEach(calibration => {
          const option = document.createElement('option')
          option.value = calibration.id
          option.textContent = calibration.display_text
          calibrationSelect.appendChild(option)
        })
        
        // Select the last item in the list if there are any calibrations
        if (data.length > 0) {
          calibrationSelect.value = data[data.length - 1].id
        }
      })
      .catch(error => {
        console.error('Error:', error)
        calibrationSelect.innerHTML = '<option value="">Error loading calibrations</option>'
      })
  }
}